import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { AddOrderNoteRequest, Note } from "./orderNotesApi";
import { addOrderNote, getOrderNotes } from "./orderNotesApi";
import { useSnackbar } from "notistack";

export const useOrderNotes = (orderId: string) => {
  const queryClient = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ["orders", orderId, "notes"],
    queryFn: ({ signal }) => getOrderNotes(orderId, signal),
  });
  const { enqueueSnackbar } = useSnackbar();

  const addNoteMutation = useMutation<Note[], unknown, AddOrderNoteRequest>({
    mutationFn: (r) => addOrderNote(orderId, r),
    onSuccess: async (notes) => {
      queryClient.setQueryData(["orders", orderId, "notes"], notes);
      enqueueSnackbar("Notatka została dodana", { variant: "success" });
    },
  });

  return {
    notes: data,
    isLoading,
    addOrderNote: (text: string, contactDate: string | null) => addNoteMutation.mutateAsync({ text, contactDate }),
  };
};
